export enum PayoutProvider {
  STRIPE = 'stripe',
  ULTIPRO = 'ultipro',
  UNKNOWN = 'unknown',
}
